import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJuliaComponent } from './simple-icons-julia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJuliaComponent ],
    exports:      [ SimpleIconsJuliaComponent ],
    bootstrap:    []
})
export class SimpleIconsJuliaModule {}
